import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";

import { TSubject, TSubjectOperation, useEditingContext } from "./Context";
import { TEditor } from "./Editor";
import { EditingProvider } from "./Provider";

export type TSubjectDialogProps = {
  children: React.ReactNode;
  subjectLabel: string;
  titleKey?: string;
  TitleEl?: (operation: TSubjectOperation<TSubject>) => React.ReactNode;
  onClose?: () => void;
};

export const SubjectDialog = ({
  children,
  onClose,
  subjectLabel = "Entity",
  titleKey = "name",
  TitleEl = (operation: TSubjectOperation<TSubject>) => {
    const { subject, isEditing } = operation;
    return (
      <span>{`${isEditing ? `Edit: ${subject?.[titleKey]}` : `New ${subjectLabel}`}`}</span>
    );
  },
}: TSubjectDialogProps) => {
  const operation = useEditingContext();

  return (
    <Dialog open={true} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle className="flex justify-between items-center">
        <TitleEl {...operation} />
        <IconButton onClick={onClose} edge="end">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export const EditingDialog = <T extends TSubject>({
  current,
  start,
  complete,
  ...params
}: TSubjectDialogProps & TEditor<T>) => {
  if (!current) return null;
  return (
    <EditingProvider current={current} complete={complete} start={start}>
      <SubjectDialog onClose={complete} {...params} />
    </EditingProvider>
  );
};
